import { render, staticRenderFns } from "./shareCodeInfo.vue?vue&type=template&id=453a5d28&"
import script from "./shareCodeInfo.vue?vue&type=script&lang=js&"
export * from "./shareCodeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports